import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import {
  type AuthPromptEntry,
  type AuthPromptRequest,
  useAuthPrompt,
} from '../../contexts/AuthPromptContext';

const REQUEST_BY_ENTRY: Record<AuthPromptEntry, AuthPromptRequest> = {
  register: { intent: 'signIn', initialTab: 'signUp', entry: 'register' },
  forgotPassword: { intent: 'signIn', initialTab: 'logIn', entry: 'forgotPassword' },
  login: { intent: 'signIn', initialTab: 'logIn', entry: 'login' },
};

/**
 * An old auth URL as a thin route: once the sign-in bootstrap has finished it opens the
 * pop-up for its entry (signed out only) and replaces itself with the home page.
 */
const AuthPromptRoute: React.FC<{ entry: AuthPromptEntry }> = ({ entry }) => {
  const { isLoading, isAuthenticated } = useAuth();
  const { openAuthPrompt } = useAuthPrompt();
  const navigate = useNavigate();
  const hasActedRef = useRef(false);

  useEffect(() => {
    if (isLoading || hasActedRef.current) return;
    hasActedRef.current = true;
    if (!isAuthenticated) openAuthPrompt(REQUEST_BY_ENTRY[entry]);
    navigate('/', { replace: true });
  }, [isLoading, isAuthenticated, entry, openAuthPrompt, navigate]);

  return null;
};

export default AuthPromptRoute;
